import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "badge"
}
const _hoisted_3 = { class: "panel-content" }
const _hoisted_4 = { class: "panel-header" }
const _hoisted_5 = { class: "panel-body" }
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = {
  key: 1,
  class: "history-list"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "item-header" }
const _hoisted_10 = { class: "strategy-name" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "item-details" }
const _hoisted_13 = { class: "detail-row" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "detail-row" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "detail-row" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "detail-row" }
const _hoisted_20 = { class: "value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['leg-volumes-panel', { 'is-open': _ctx.isOpen }])
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePanel && _ctx.togglePanel(...args))),
      class: "panel-toggle",
      title: _ctx.isOpen ? 'Close History' : 'Open History'
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(_ctx.isOpen ? 'fas fa-chevron-right' : 'fas fa-chevron-left')
      }, null, 2),
      (!_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.savedCalculations.length), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Leg Volumes History", -1)),
        (_ctx.savedCalculations.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearHistory && _ctx.clearHistory(...args))),
              class: "clear-btn",
              title: "Clear History"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.savedCalculations.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-history" }, null, -1),
              _createElementVNode("p", null, "No saved calculations yet", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedCalculations, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "history-item",
                  onClick: ($event: any) => (_ctx.openCalculation(item))
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.strategyName), 1),
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.removeItem(index)), ["stop"]),
                      class: "remove-btn",
                      title: "Remove"
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                    ]))], 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "Key Product:", -1)),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(item.keyProductName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "Key Volume:", -1)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(item.keyVolume), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Products:", -1)),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(item.productCount) + " legs", 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Date:", -1)),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(item.timestamp)), 1)
                    ])
                  ])
                ], 8, _hoisted_8))
              }), 128))
            ]))
      ])
    ])
  ], 2))
}